import { createRoute, redirect } from '@tanstack/react-router'

import { meQueryOptions } from '@/shared/auth/session'
import { isApiError } from '@/shared/api/problem'
import { navigation } from '@/app/navigation'
import { AppShell } from '@/shared/layout/app-shell'
import { AppShellSkeleton } from '@/shared/layout/app-shell-skeleton'

import { rootRoute } from './root'

/**
 * Layout das telas autenticadas. Garante a sessão (GET /me) antes de renderizar;
 * sem sessão, redireciona para /login preservando o destino.
 */
export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authenticated',
  beforeLoad: async ({ context, location }) => {
    try {
      const admin = await context.queryClient.ensureQueryData(meQueryOptions)

      return { admin }
    } catch (error) {
      if (isApiError(error) && error.status === 401) {
        throw redirect({ to: '/login', search: { redirect: location.href } })
      }

      throw error
    }
  },
  // O beforeLoad (GET /me) é o que pode demorar; o skeleton só entra se passar de 150 ms.
  pendingComponent: AppShellSkeleton,
  pendingMs: 150,
  pendingMinMs: 300,
  component: () => <AppShell navigation={navigation} />,
})
